import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f705cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar shadow-sm px-5 p-0 bg-white rounded" }
const _hoisted_2 = { class: "col-sm-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = {
  key: 0,
  class: "button-login"
}
const _hoisted_6 = { class: "mb-0 mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_LandingView = _resolveComponent("LandingView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "ms-3 navbar-brand float-start",
          src: require('@/assets/images/logo_iosi_blue.png'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.userInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("b", {
                  class: "cursor-pointer btn-cancel",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Register' })))
                }, _toDisplayString(_ctx.$t("menu.register")), 1)
              ]),
              _createVNode(_component_ds_button, {
                class: "d-flex align-items-center",
                type: "primary",
                action: "button",
                text: _ctx.$t('menu.login'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.login()))
              }, null, 8, ["text"])
            ]))
          : (_openBlock(), _createBlock(_component_ds_button, {
              key: 1,
              class: "d-flex align-items-center",
              type: "primary",
              action: "button",
              text: _ctx.userInfo.name,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirect()))
            }, null, 8, ["text"]))
      ])
    ]),
    _createVNode(_component_LandingView)
  ]))
}